import { render, staticRenderFns } from "./u-card-flat-rounded.vue?vue&type=template&id=791c81c0&scoped=true&"
import script from "./u-card-flat-rounded.vue?vue&type=script&lang=js&"
export * from "./u-card-flat-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c81c0",
  null
  
)

export default component.exports